// Web Audio API alert sounds for extreme scores (±4, ±5)
let audioCtx = null;
let lastSoundTime = 0;
const COOLDOWN_MS = 30000; // 30 seconds

function getAudioContext() {
  if (!audioCtx || audioCtx.state === 'closed') {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
  return audioCtx;
}

export function playAlertSound(type) {
  const now = Date.now();
  if (now - lastSoundTime < COOLDOWN_MS) return;
  lastSoundTime = now;

  try {
    const ctx = getAudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'sine';

    if (type === 'bear') {
      // Descending: E4 → C4
      osc.frequency.setValueAtTime(330, ctx.currentTime);
      osc.frequency.setValueAtTime(262, ctx.currentTime + 0.25);
    } else {
      // Ascending: C4 → E4
      osc.frequency.setValueAtTime(262, ctx.currentTime);
      osc.frequency.setValueAtTime(330, ctx.currentTime + 0.25);
    }

    gain.gain.setValueAtTime(0.15, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.5);

    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.5);
  } catch {
    // Audio not available
  }
}

export function getSoundEnabled() {
  return localStorage.getItem('macroflare_sound') !== 'off';
}

export function setSoundEnabled(enabled) {
  localStorage.setItem('macroflare_sound', enabled ? 'on' : 'off');
}
